import React, { useState } from "react";
import CButton from "../../components/CButton";
import { ReactComponent as ClearIcon } from "../../assets/images/eraser-icon.svg";


function OrganogramTree() {

  return (
    <div>
      <h2 className="text-3xl leading-3xl text-blue-500 font-semibold mb-4">
        Organogram
      </h2>
      <div className="border-2 border-blue-500 bg-white rounded-lg p-4 md:mb-6 mb-4 relative">
        <p className="bg-white text-lg font-semibold text-gray-700 mb-4 2xl:text-xl 2xl:leading-xl lg:text-base lg:leading-base text-sm leading-sm absolute md:top-[-16px] top-[-12px] left-[16px] px-1">Instructions</p>
        <div>
          <p className="font-medium mb-2 2xl:text-base text-sm 2xl:leading-base leading-sm text-gray-300">
            The organogram should consist of the organizational hierarchy
            clearly stating the Department structure like parent department, sub
            department and the lead of the departments. Here is the template to
            upload the Organogram in the system. &nbsp;
            <CButton className="text-blue-600 underline font-semibold 2xl:!h-auto !h-auto 2xl:!p-0 !p-0">
              Click here to download.
            </CButton>
          </p>
          <p className="font-medium 2xl:text-base text-sm 2xl:leading-base leading-sm text-gray-300">
            Leave the parent department field empty if the department you are
            entering is the parent department and if you are adding the child
            department make sure to mention the parent department.
          </p>
        </div>
      </div>
      <div className="bg-white border border-solid border-blue-200 rounded-xl overflow-hidden p-6 ">
        <div className="flex justify-end gap-2 mt-2 md:mt-0">
            <CButton className="bg-blue-75 text-blue-500  hover:bg-blue-100 border border-solid border-blue-300 rounded-lg p-0 mrs-3 ">
              <ClearIcon/>Clear Data
            </CButton>
            <CButton className=" gradient-btn text-white shadow-none">
              Upload Excel
            </CButton>
        </div>
        <div className="text-center text-gray-500 text-sm mt-4 h-[200px] flex items-center justify-center">
            <p className="text-gray-700 text-lg font-semibold">No results found.</p>
        </div>
      </div>
    </div>
  );
}

export default OrganogramTree;
